import React, { Component } from 'react';
import Navigation from "../Navigation/Navigation";
import Footer from "../General/Footer";
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CreateBoat from './CreateBoat';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

class CreateRide extends Component {
    constructor(props) {
        super(props)
        this.state = {
            category: ""
        }
        this.renderForm = this.renderForm.bind(this)
    }
    renderForm() {
        switch (this.state.category) {
            case "Boat":
                return <CreateBoat typeGroup={this.state.category} />
            default:
                return
        }
    }
    render() {
        if (!this.props.user.userProfile) {
            return <Redirect to="/" />
        }
        return (
            <div className="createride__main">
                <Navigation auth={this.props.auth} />
                <div className="page__hero">
                    <h4 className="page-title page__hero__title">Add your ride</h4>
                </div>
                <div className="createride__container">
                    <div className="createride__fields__container">
                        <Form>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group controlId="formGridState">
                                        <Form.Label className="createride__category__title">Category</Form.Label>
                                        <Form.Control as="select" value={this.state.category} onChange={(e) => this.setState({ category: e.target.value })}>
                                            <option></option>
                                            <option>Boat</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                        {this.renderForm()}
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default connect((state) => {
    return { user: state.reducerUser }
})(CreateRide);